import $http from "@/plugins/axios";
const MADTemplateService = {
    create(botCode, data) {
        return $http.post(`/live-support/mad-template/${botCode}`, data);
    },
    findAll(botCode) {
        return $http.get(`/live-support/mad-template/${botCode}`)
    },
    findById(botCode, id) {
        return $http.get(`/live-support/mad-template/${botCode}/${id}`)
    },
    update(botCode, data) {
        return $http.put(`/live-support/mad-template/${botCode}/${data._id}`, data)
    },
    deleteOne(botCode, id) {
        return $http.delete(`/live-support/mad-template/${botCode}/${id}`);
    },
}

export default MADTemplateService;
